import closeMenu from './close-menu.action';

export default closeMenu;
